import { render, staticRenderFns } from "./TeamRegionMemberControls.vue?vue&type=template&id=a480bd9e&scoped=true&"
import script from "./TeamRegionMemberControls.vue?vue&type=script&lang=js&"
export * from "./TeamRegionMemberControls.vue?vue&type=script&lang=js&"
import style0 from "./TeamRegionMemberControls.vue?vue&type=style&index=0&id=a480bd9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a480bd9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a480bd9e')) {
      api.createRecord('a480bd9e', component.options)
    } else {
      api.reload('a480bd9e', component.options)
    }
    module.hot.accept("./TeamRegionMemberControls.vue?vue&type=template&id=a480bd9e&scoped=true&", function () {
      api.rerender('a480bd9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamRegionMemberControls.vue"
export default component.exports